module.exports = __webpack_public_path__ + "img/img-douyin.8cb5d06a.png";